// @flow
import { styled } from 'mz-ui-kit'
import { safePseudoelem, getDeviceStyles } from '../../../utils'

const SCROLL_STYLES = ($palette) =>
  getDeviceStyles(
    {
      ...safePseudoelem('::-webkit-scrollbar', {
        width: '8px',
        height: '8px',
      }),
      ...safePseudoelem('::-webkit-scrollbar-thumb', {
        background: `${$palette('primary')}`,
        border: `0px none ${$palette('white')}`,
        borderRadius: '5px',
        ':hover': { background: `${$palette('primary').darken(10)}` },
        ':active': { background: `${$palette('primary').darken(10)}` },
      }),
      ...safePseudoelem('::-webkit-scrollbar-track', {
        background: 'transparent',
        ':hover': { background: 'transparent' },
        ':active': { background: 'transparent' },
      }),
      ...safePseudoelem('::-webkit-scrollbar-corner', {
        background: 'transparent',
      }),
    },
    {}
  )

export const Container = styled<{
  $maxHeight?: string,
}>('div', ({ $maxHeight, $palette }) => ({
  margin: 0,
  padding: 0,
  listStyleType: 'none',
  WebkitOverflowScrolling: 'touch',
  flexGrow: 1,
  overflow: 'visible',
  ...SCROLL_STYLES($palette),
  ...($maxHeight && {
    position: 'relative',
    maxHeight: $maxHeight,
    overflow: 'auto',
  }),
}))
